<div class="row">
    <ul class="breadcrumb">
        <li>
            <a routerLink="/ficha">
                <em class="fa fa-home"></em> Omni Mais</a>
        </li>
        <li>
            <a [routerLink]="routerCurrentPage" class="active">{{currentPage}}</a>
        </li>
        <li *ngIf="currentPageDetail" class="active">{{currentPageDetail}}</li>
    </ul>

    <ng-content></ng-content>

    <a *ngIf="voltar === 'show'" routerLink="/ficha" title="Voltar para a lista de fichas" class="back-page">
        <em class="fa fa-arrow-left"></em> Voltar
    </a>
</div>
